import { Head } from '@cinch-nx/landing-ui-shared'
import Link from 'next/link'
import React from 'react'

export function Index() {
  return (
    <>
      <Head
        fallbackTitle="Cars Without The Faff - cinch"
        fallbackDescription="Welcome to cinch, the faff free way to buy & sell cars. We have thousands of used cars, ready to be sold to you."
      />

      <div
        style={{
          height: '50vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-evenly',
          alignItems: 'center',
          margin: '2rem auto',
        }}
      >
        <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>
          Welcome to Landing Articles!
        </h1>

        <ul className="internalLinkList">
          <li>
            <Link href="/guides">Guides</Link>
          </li>
          <li>
            <ul className="internalLinkList">
              <li>
                <Link href="/guides/ask-the-experts">Ask the Experts</Link>
              </li>
              <li>
                <Link href="/guides/car-finance">Car Finance</Link>
              </li>
              <li>
                <Link href="/guides/car-maintenance">Car Maintenance</Link>
              </li>
              <li>
                <Link href="/guides/choosing-a-car">Choosing a Car</Link>
              </li>
              <li>
                <Link href="/guides/electric-cars">Electric Cars</Link>
              </li>
              <li>
                <Link href="/guides/new-drivers">New Drivers</Link>
              </li>
            </ul>
          </li>
          <li>
            <Link href="/news">News</Link>
          </li>
          <li>
            <Link href="/announcements/cinch-news">Announcements</Link>
          </li>
          <li>
            <Link href="/reviews">Car reviews V2</Link>
          </li>
          <li>
            <Link href="/electric-cars">Electric Cars Page</Link>
          </li>
        </ul>
      </div>
    </>
  )
}

export default Index
